(function ($, Global) {
    var _createImg = function (src, callback) {
        var $img = $('<img />', {
            class: 'img-fluid'
        });
        $img.on('load',function () {
            if (typeof callback == 'function') callback();
        });
        $img.trigger('load')
        $img.attr('src', src);

        return $img;
    };
    var _createCaption = function (caption) {
        return $('<figcaption>' + caption + '</figcaption>');
    }
    var _createFigure = function ($image, $caption) {
        var $figure = $('<figure />');
        $image.appendTo($figure);

        if ($caption) $caption.appendTo($figure);

        return $figure;
    }

    var ModalImgFullscreenComponent = function ($modal) {
        if ($modal && $modal.exists()) {
            this.$modal = $modal;
            this.$container = this.$modal.find('.modal-img-container');           
            this.imgSrc = '';
            this.caption = '';
        } else {
            console.error('Selector is missing');
        }
    };

    ModalImgFullscreenComponent.prototype.initEvents = function () {
        this.subscribers();
    };

    ModalImgFullscreenComponent.prototype.subscribers = function () {
        var self = this;

        $.Topic('modal-img-fullscreen-load').subscribe(function (src, caption) {
            self.toggleLoading();
            self.$modal.modal('show');
            self.loadImg(src, caption);
        });
    };

    ModalImgFullscreenComponent.prototype.loadImg = function (src, caption) {
        var self = this;
        if (self.imgSrc !== src) {            
            self.$container.empty();
            var $figure;
            var $newImg = _createImg(src, function () {
                self.imgSrc = src;
                $.Topic('loader-hide').publish(self.$container.parent());
            });

            if (caption) {
                var $caption = _createCaption(caption);
                $figure = _createFigure($newImg, $caption);
            } else {
                $figure = _createFigure($newImg);
            }

            self.$container.html($figure);
        } else {
            self.toggleLoading();
        }
    };

    ModalImgFullscreenComponent.prototype.toggleLoading = function () {
        var $parentContainer = this.$container.parent();
        var actionLoading = $parentContainer.hasClass('loading') ? 'loader-hide' : 'loader-show';

        $.Topic(actionLoading).publish($parentContainer);
    };

    Global.ModalImgFullscreenComponent = ModalImgFullscreenComponent;
}(jQuery, window));